import React from 'react'
import { Grid } from '@material-ui/core';
import { withStyles, createStyles } from '@material-ui/core/styles';
import SectionTitle from '../../components/SectionTitle';
import ProjectCard from '../../components/singleproject/ProjectCard';
import CenterContentNarrow from '../../components/CenterContentNarrow';
import CtaCarouselSlider from '../../components/Carousel/CtaCarouselSlider';

const styles = theme =>
  createStyles({
    similarProjectsWrap: {
      display: 'none',

      [theme.breakpoints.up(960)]: {
        display: 'block',
        paddingTop: 62,
        paddingBottom: 120,
      },
    },

    projectSliderWrap: {
      paddingTop: 50,
      display: 'block',
      [theme.breakpoints.up(960)]: {
        display: 'none',
        paddingTop: 0,
      },
    },

    cardsWrap: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: 15,
      [theme.breakpoints.up(767)]: {
        marginTop: 30
      },
     },

    projectSlider: {
      marginTop: 20,
    }
  });

const SimilarProjects = ({title="Similar Projects", cards = [], classes}) => {
  return (
    <React.Fragment>
      <CenterContentNarrow style={{maxWidth: '1020px'}}>
      <Grid
        container
        direction="column"
        className={classes.similarProjectsWrap}
      >
        <SectionTitle
          title={title}
        />
        <Grid
          container
          className={classes.cardsWrap}
        >
          {cards.map((item) => (
            <ProjectCard
              key={item.id}
              cardImage={item?.imagePath}
              ctaTitle={item?.ctaTitle}
              ctaText={item?.ctaText || 'Learn More'}
              ctaHref={item?.ctaHref}
             />
            ))}
        </Grid>
      </Grid>
        {/* MOBILE SLIDER */}
        <div className={classes.projectSliderWrap}>
          <SectionTitle
            title={title}
         /> 
          <div
            className={classes.projectSlider}
          >
            <CtaCarouselSlider mediumImage items={cards} />
          </div>
        </div>     
      </CenterContentNarrow>
    </React.Fragment>
  )
}

export default withStyles(styles, { withTheme: true })(SimilarProjects);
